import { Injectable, computed, signal } from '@angular/core';
import { SyncState, SyncStatusInfo } from '../../layout/app-shell/models/sync-status.model';

const TITLES: Record<SyncState, string> = {
  normal: 'Operação normal',
  syncing: 'Sincronizando',
  attention: 'Atenção',
  error: 'Erro na sincronização',
  offline: 'Offline',
};

/**
 * STUB — a origem real do status de sincronização (backend/worker) ainda
 * não foi definida. Estado inicial neutro ('normal') até a integração real
 * existir. SyncStatusComponent nunca deve exibir texto fixo/genérico,
 * sempre lendo o título + a mensagem contextual daqui.
 */
@Injectable({ providedIn: 'root' })
export class SyncStatusService {
  private readonly _state = signal<SyncState>('normal');
  /** Horário do último sync bem-sucedido — usado para compor a mensagem contextual. */
  private readonly _lastSyncAt = signal<Date>(new Date());

  readonly state = this._state.asReadonly();
  readonly lastSyncAt = this._lastSyncAt.asReadonly();

  readonly status = computed<SyncStatusInfo>(() => {
    const state = this._state();
    return {
      state,
      title: TITLES[state],
      message: this.buildMessage(state),
    };
  });

  setState(state: SyncState): void {
    this._state.set(state);
  }

  setLastSyncAt(date: Date): void {
    this._lastSyncAt.set(date);
  }

  private buildMessage(state: SyncState): string {
    switch (state) {
      case 'offline':
        return 'Sem conexão com o servidor';
      case 'error':
        return 'Falha ao sincronizar · tente novamente';
      case 'syncing':
        return `Enviando alterações · atualizado ${this.formatElapsed()}`;
      case 'attention':
        return `Pendências aguardando revisão · atualizado ${this.formatElapsed()}`;
      case 'normal':
      default:
        return `Atualizado ${this.formatElapsed()}`;
    }
  }

  private formatElapsed(): string {
    const diffMs = Date.now() - this._lastSyncAt().getTime();
    const minutes = Math.floor(diffMs / 60_000);
    if (minutes < 1) return 'agora';
    if (minutes < 60) return `há ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    return `há ${hours} h`;
  }
}
